<template>
	<div class="roll-info">
		<div class="roll-desc">
			<div class="caption">
				福利ROLL房
			</div>
			<div class="info">
				<div class="info-bg">
					<template v-if="data.user.anchor_icon ==1">
						<img :src="data.user.avatar" alt="">
						<div class=anchor_icon>	</div>
					</template>
					<template v-else-if="data.user.anchor_icon ==2">
						<img :src="data.user.avatar" alt="">
						<div class=anchor_icon_gf>	</div>
					</template>
					<template v-else>
						<img :src="data.user.avatar" alt="">
						<img v-if="data.user.vipLevel != 0" class=pic_vip :src="GetVipIcon(data.user.vipLevel)" alt="">
					</template>

				</div>
		
				<div class="info-left">
					<p class="name">{{ data.name }}</p>
					<p class="desc">{{ data.describe }}</p>
				</div>
				<div class="join" v-show="data.status == 1" @click="JoinHome()">
					<p>+我要加入</p>
				</div>
			</div>
		</div>
		<div class="roll-award">
			<div class="top">
				<div class="top-caption">
					<p>包含礼品</p>
				</div>
				<div class="top-content" >
					<span>共有<span style="color: #FFD077;font-family: Oxanium;">{{ data.box_records.length }}</span>件，</span>
					<span>总价值：<span style="color:#FFD077;font-family: Oxanium;">${{ data.award_bean }}</span></span>
				</div>
			</div>

			<!--活动奖池-->
			<!---
			:style="'background-image: url(' + value.lv_bgImage + ')'"
			-->
			<div class="item-list">
				<div v-for="(value, key) in data.box_records" class="item" :key="key">
					<div class="price"><img src="@/assets/images/PublicImg/JinBi.png" alt="">{{ value.bean }}</div>
					<div class="pic">
						<img :src="value.cover" alt="" />
					</div>
					<div class="name">{{ value.name }}</div>
				</div>
			</div>
			
			<!--获奖玩家-->
			<div v-if="data.status == 2">
				<div class="top">
					<div class="top-caption">
						<p>获奖玩家</p>
					</div>
					<div class="top-content">
						<span>共<span style="color: #FFD077;">{{ data.join_number}}</span>人</span>
					</div>
				</div>
				<div class="awards-list">
					<div v-if="roomUserId != value.user.id" v-for="(value, key) in data.box_records" class="line" :key="key">
						<div :class="'award'">
							<div class="price"><img src="@/assets/images/PublicImg/JinBi.png" alt="">{{ value.bean }}</div>
							<div class="pic">
								<img :src="value.cover" alt="" />
							</div>
							<div class="name">{{ value.name }}</div>
						</div>
						<div class="user">
							<div class="header">
								<img :src="value.user ? value.user.avatar : ''" alt="" />
							</div>
							<div class="name">{{ value.user ? value.user.name : "" }}</div>
						</div>
					</div>
				</div>
			</div>

			<div class="top">
				<div class="top-caption">
					<p>参与玩家</p>
				</div>
				<div class="top-content">
					<span>共<span style="color: #FFD077;">{{ data.join_number}}</span>人</span>
				</div>
			</div>
		</div>

		<!---参与玩家--->
		<div class="block item-box">
			<div class="user-list">
				<div class="item" v-for="(value, key) in data.room_users" :key="key">
					<div class="header">
						
						<!-- <img :src="value.avatar" alt="" />
						<img v-if="value.vipLevel != 0" class=pic_vip :src="GetVipIcon(value.vipLevel)" alt=""> -->

						<template v-if="value.anchor_icon ==1">
							<img class=pic_icon :src="value.avatar" alt="">
							<div class=anchor_icon>	</div>
						</template>
						<template v-else-if="value.anchor_icon ==2">
							<img class=pic_icon :src="value.avatar" alt="">
							<div class=anchor_icon_gf>	</div>
						</template>
						<template v-else>
							<img class=pic_icon :src="value.avatar" alt="">
							<img v-if="value.vipLevel != 0" class=pic_vip :src="GetVipIcon(value.vipLevel)" alt="">
						</template>



					</div>
					<div class="name">{{ value.name }}</div>
				</div>
			</div>
		</div>
		<transition name="fade">
			<div class="input-box" v-show="input">
				<div class="box">
					<div class="pwd">
						<el-input placeholder="请输入密码" v-model="pwd" show-password></el-input>
					</div>
					<div class="btn close" @click="input = false">取消</div>
					<div class="btn verify" @click="JoinHome(pwd)">确认</div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
import {
	SRollInfo,
	SJoinHome
} from "@/network/server";
import myMixin from "@/utils/mixin";
export default {
	mixins: [myMixin],
	data() {
		return {
			data: {
				name: "",
				start_time: "",
				end_time: "",
				status: 0,
				box_records: [],
				user: {
					avarar: "",
				},
				room_users: [],
				join_number: 0,
				award_bean: 0,

			},
			input: false,
			pwd: "",
			roomUserId: 0,//房主id
		};
	},

	created() {
		this.RollInfo();
	},
	watch: {
		$route(to, from) {
			if (to.name == "room") {
				this.RollInfo();
			}
		},
	},
	methods: {
		GetVipIcon(level) {
			if (level == 1) {
				return require('@/assets/images/vip/VIP-1.png');
			} else if (level == 2) {
				return require('@/assets/images/vip/VIP-2.png');
			} else if (level == 3) {
				return require('@/assets/images/vip/VIP-3.png');
			} else if (level == 4) {
				return require('@/assets/images/vip/VIP-4.png');
			} else if (level == 5) {
				return require('@/assets/images/vip/VIP-5.png');
			}
			else if (level == 6) {
				return require('@/assets/images/vip/VIP-6.png');
			}
			else if (level == 7) {
				return require('@/assets/images/vip/VIP-7.png');
			}
			else if (level == 8) {
				return require('@/assets/images/vip/VIP-8.png');
			}
			else if (level == 9) {
				return require('@/assets/images/vip/VIP-9.png');
			}
			else if (level == 10) {
				return require('@/assets/images/vip/VIP-10.png');
			}
			else if (level == 11) {
				return require('@/assets/images/vip/VIP-11.png');
			}
			else if (level == 12) {
				return require('@/assets/images/vip/VIP-12.png');
			}
			return require('@/assets/images/vip/VIP-1.png');
		},

		RollInfo() {
			SRollInfo(this.$route.query.id).then((data) => {
				this.data = data;
				this.roomUserId = data.user.id;
				console.log(this.data);

				if(data.box_records.length > 150){
					this.data.box_records.length=150;
				}
					
			});
		},
		JoinHome(pwd) {
			if (this.data.is_pwd && !pwd) {
				this.input = true;
				return;
			}
			SJoinHome(this.$route.query.id, pwd)
				.then((data) => {
					this.Success("加入成功");
					this.input = false;
				})
				.catch((err) => {
					this.Err(err.message);
					this.input = false;
				});
		},
	},
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
	transition: all 0.5s;
}

.fade-enter,
.fade-leave-to {
	transform: translateX(3rem);
	opacity: 0;
}

.roll-info {
    width: 100%;
	//padding-top: 20px;
	.roll-desc {
		width: 100%;
		background: url(../../assets/images/new-ui/box_type_title.png) no-repeat center;
		background-size: 100% 100%;

		.caption {
			padding-top: 20px;
			padding-left: 20px;
			font-size: 16px;
			font-weight: 600;
			color: #E9B85A;
		}

		.info {
			flex: 1;
			min-width: 0;
			display: flex;
			align-items: center;
			padding: 20px;

			.info-bg {
				flex-shrink: 0;
				width: 60px;
				height: 60px;
				border-radius: 50%;
				overflow: hidden;
				border: 1px solid #ffba2e;
				box-sizing: border-box;
				display: flex;
				justify-content: center;
				align-items: center;
				img {
					width: 130%;
					height: 130%;
				}

				.pic_vip {
					width: 40px;
					height: 40px;
					position: absolute;
					display: flex;
					justify-content: center;
					align-items: center;
					z-index: 10;
					margin-top: 50px;
					img {
						max-width: 100%;
						max-height: 100%;
					}
				}
				.anchor_icon{
					width: 74px;
					height: 74px;
					position: absolute;
					z-index: 10;
					background: url(../../assets/images/vip/anchor.png) no-repeat 0;
					background-size: 100% 100%;
				}
				.anchor_icon_gf{
					width: 74px;
					height: 74px;
					position: absolute;
					z-index: 10;
					background: url(../../assets/images/vip/gf.png) no-repeat 0;
					background-size: 100% 100%;
				}
			}

			.info-left {
				flex: 1;
				min-width: 200px;
				padding-left: 10px;
				padding-right: 10px;
				.name {
					font-size: 15px;
					font-weight: 600;
					margin-bottom: 3px;
                    font-family: 'Oxanium';
				}

				.desc {
					font-size: 13px;
					color: #707694;
					margin-bottom: 3px;
                    font-family: 'Oxanium';
				}

			}

			.join {
				width: 150px;
				height: 36px;
				cursor: pointer;
				display: flex;
				justify-content: center;
				align-items: center;
				color: #ffffff;
				background-image: linear-gradient(90deg, #6f5a39, #6f4c2c);
				background-blend-mode: normal, normal;
				border-radius: 8px;
				border: 1px solid #dcae64;
				user-select: none;
				transition: all .3s ease;

				&:hover {
					background-image: linear-gradient(90deg, #6f5a39, #47321d);
				}

				&:first-child {
					margin-right: 0.08rem;
				}

				p {
					font-size: 16px;
				}

			}

		}
	}

	.roll-award {
		width: 100%;
		padding-top: 10px;
		.top {
			height: 30px;
			display: flex;
			align-items: center;
			border-bottom: 1px solid hsla(0, 0%, 100%, .08);
			.top-caption {
				padding-left: 20px;
				padding-right: 10px;
				font-size: 15px;
				font-weight: 600;
			}

			.top-content {
				font-size: 13px;
			}
		}

		.item-list {
			width: 100%;
			display: flex;
			flex-wrap: wrap;
			.item {
				width: 225px;
				margin: 4px;
				text-align: center;
				background: url(../../assets/images/Roll/LV1.png) no-repeat center;
				background-size: 100% 100%;

				.pic {
					width: 100%;
					height: 140px;
					display: flex;
					justify-content: center;
					align-items: center;
					img {
						max-width: 100%;
						max-height: 100%;
					}
				}


				.name {
					width: 100%;
					font-size: 14px;
					margin-bottom: 10px;
                    font-family: 'Oxanium';
				}

				.quality {
					width: 100%;
					font-size: 10px;
				}

				.price {
					font-size: 15px;
					margin-top: 10px;
					display: flex;
					justify-content: center;
					align-items: center;
					color: #FFD077;
                    font-family: 'Oxanium';
					img {
						width: 20px;
						height: 20px;
						vertical-align: middle;
					}
				}
			}
		}
		.awards-list {
			display: flex;
			flex-wrap: wrap;
			position: relative;

			.line {
				position: relative;
                width: 225px;
	            margin: 4px;
				background: url(../../assets/images/Roll/LV1.png) no-repeat center;
				background-size: 100% 100%;
				.award {
                    width: 225px;
					text-align: center;
					background-size: 100% 100%;

                    .pic {
                        width: 100%;
                        height: 140px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        img {
                            max-width: 100%;
                            max-height: 100%;
                        }
				    }

					.name {
						width: 100%;
						box-sizing: border-box;
						margin-bottom: 10px;
						font-size: 14px;
                        font-family: 'Oxanium';
					}

					.quality {
						width: 100%;
						font-size: 14px;
					}

					.price {
                        font-size: 15px;
                        margin-top: 10px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        color: #FFD077;
                        font-family: 'Oxanium';

                        img {
                            width: 20px;
                            height: 20px;
                            vertical-align: middle;
					    }
					}
				}

				.user {
					width: 100%;
					display: flex;
					justify-content: center;
					align-items: center;
					margin-bottom: 10px;

					.header {
						width: 30px;
						height:30px;
						border-radius: 50%;
						overflow: hidden;
						margin-right: 5px;

						img {
							width: 100%;
							height: 100%;
						}
					}

					.name {
						font-size: 14px;
					}
				}
			}
		}

	}




	.block {
		position: relative;
		background-size: cover;
		margin: 0.3rem 0 0.2rem;
		padding: 0.02rem;
		overflow: hidden;

		.info {
			margin: .2rem auto;
			text-align: center;
		}
	}

	.roll-head {
		// height: 1.6rem;
		text-align: center;

		.header {
			margin: 0.2rem;
			width: 1.6rem;
			height: 1.6rem;
			background-color: rgb(80, 80, 80);
			background-size: 100% 100%;
			border-radius: 50%;
			text-align: center;
			line-height: 1.2rem;
			font-size: 0.32rem;
			font-weight: bold;
			margin: 0 auto;

		}

		.name {

			margin: .2rem 0;
		}

		.limit {
			font-size: 0.16rem;
		}

		.MiaoShu {
			height: 0.3rem;
			line-height: 0.3rem;
			font-size: 0.16rem;
			white-space: nowrap; //不换行
			overflow: hidden; //超出隐藏
			text-overflow: ellipsis; //变成...
			margin: .2rem 0;
		}

		.time {

			font-size: 0.2rem;
			margin-bottom: .2rem;
		}

		.btn {
			margin: 0 auto;
			width: 2rem;
			height: .4rem;
			background: #ffd300;
			border-radius: .04rem;
			text-align: center;
			line-height: .4rem;
			color: #000;
			font-size: .22rem;
			cursor: pointer;
		}
	}

	.item-box {
		.awards-list {
			display: flex;
			flex-wrap: wrap;
			position: relative;

			.line {
				position: relative;
				width: 2rem;
				overflow: hidden;
				margin-right: .39rem;
				background: url(../../assets/images/public/back_pub.jpg) no-repeat center;
				background-size: 100% 100%;
				margin-bottom: .3rem;

				&:nth-child(6n) {
					margin-right: 0;
				}

				.award {
					width: 2rem;

					text-align: center;
					background-size: 100% 100%;

					.pic {
						width: 100%;
						height: 1.2rem;
						background-repeat: no-repeat;
						background-size: 60%;
						background-position: center;
						display: flex;
						justify-content: center;
						align-items: center;
						margin-bottom: .1rem;

						img {
							max-width: 80%;
							max-height: 80%;
						}
					}

					.name {
						width: 100%;
						padding: 0 .05rem;
						box-sizing: border-box;
						margin-bottom: .16rem;
						font-size: 0.5em;
					}

					.quality {
						width: 100%;
						font-size: 0.5em;
					}

					.price {
						font-size: 0.14rem;
						margin: 0.1rem;
						display: flex;
						justify-content: center;
						align-items: center;

						img {
							width: .2rem;
							height: .2rem;
							vertical-align: middle;
							margin: 0;
							margin-right: 0.03rem;
						}
					}
				}

				.user {
					width: 100%;
					display: flex;
					justify-content: center;
					align-items: center;
					margin-bottom: .12rem;

					.header {
						width: 0.3rem;
						height: 0.3rem;
						border-radius: 50%;
						overflow: hidden;
						margin-right: .05rem;

						img {
							width: 100%;
							height: 100%;
						}
					}

					.name {
						font-size: 0.5em;
					}
				}
			}
		}
		
		.user-list {
			display: flex;
			flex-wrap: wrap;

			.item {
				width: 100px;
				margin: 20px;
				text-align: center;

				.header {
					width: 80px;
					height: 80px;
					border-radius: 50%;
					overflow: hidden;

					img {
						width: 80px;
						height: 80px;
					}
					.anchor_icon{
                        width: 100px;
						height: 100px;
						margin-left: -9px;
						margin-top: -96px;
						position: absolute;
						background: url(../../assets/images/vip/anchor.png) no-repeat 0;
						background-size: 100% 100%;
					}
					.anchor_icon_gf{
                        width: 100px;
						height: 100px;
						margin-left: -9px;
						margin-top: -96px;
						position: absolute;
						background: url(../../assets/images/vip/gf.png) no-repeat 0;
						background-size: 100% 100%;
					}
					.pic_icon {
						img {
							max-width: 100%;
							max-height: 100%;
						}
	
					}
					.pic_vip {
						width: 50px;
						height: 50px;
						margin-left: -38px;
						margin-top: 40px;
						position: absolute;
					}

				}

				.name {
                    margin-top: 10px;
					width: 100%;
					font-size:12px;
				}

			}
		}
	}

	.input-box {
		position: fixed;
		top: 3rem;
		right: 0.3rem;
		box-shadow: 0.02rem 0.02rem 0.1rem rgb(0, 0, 0);
		z-index: 200;

		.box {
			width: 2.8rem;
			height: 1.3rem;
			background: rgb(39, 39, 39);
			border-radius: 0.03rem;

			.pwd {
				position: absolute;
				width: 2.4rem;
				height: 0.4rem;
				margin: 0.2rem;
			}

			@include input(rgb(218, 218, 218));

			.btn {
				position: absolute;
				box-sizing: border-box;
				@include btn(1.1rem,
					0.4rem,
					rgb(218, 218, 218));
			}

			.close {
				left: 0.2rem;
				top: 0.7rem;
				font-size: 18px;
			}

			.verify {
				right: 0.2rem;
				top: 0.7rem;
			}
		}
	}
}</style>
